/*$('.slider-poi').flickity({
  wrapAround: true,
  pageDots: false,
  prevNextButtons: false
});

$('.slider-poi__nav').flickity({
  asNavFor: '.slider-poi',
  cellAlign: 'left',
  wrapAround: true,
  pageDots: false,
  prevNextButtons: false
});*/
/*$('.slider-poi__slide').each(function(index){
    var time = index * 2000;
    var slide = $(this); // this is bound to .each()

    setInterval(function(){
        // scope changed, this is bound to window
        slide.toggleClass('is-selected');
    }, time);
});*/


$('.slider-poi__nav li').click(function() {
    var tab_id = $(this).attr('data-tab');

    $('.slider-poi__nav li').removeClass('is-selected');
    $('.slider-poi__slide').removeClass('is-selected');

    $(this).addClass('is-selected');
    $("#" + tab_id).addClass('is-selected');
});
